import React from 'react';

const DriverPrivacyPolicy = () => {
  return (
    <div className="bg-[#F6F7F8]">
      <div className="container mx-auto py-12 text-gray-800">
        <div className="max-w-4xl mx-auto bg-white my-16 p-6 md:p-10 rounded-lg">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 text-center">
            Politique de Confidentialité – Livreurs OuiGoo
          </h1>
          <p className="text-center text-gray-500 mb-8">
            Dernière mise à jour : 1er juillet 2025
          </p>

          <p className="mb-6">
            Chez Ozinex, éditeur de la plateforme OuiGoo, nous attachons une grande importance à la protection de vos données personnelles et au respect de votre vie privée.
          </p>
          <p className="mb-8">
            La présente Politique de confidentialité explique quelles données nous collectons auprès des Livreurs, comment nous les utilisons, les protégeons et quels sont vos droits concernant ces données.
          </p>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Responsable du Traitement</h2>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="font-semibold">Ozinex</p>
              <p>Service OuiGoo</p>
              <p>Email : <a href="mailto:hello@ouigoo.co" className="text-primary-custom hover:underline">hello@ouigoo.co</a></p>
              <p>Site web : <a href="https://ouigoo.co" target="_blank" rel="noopener noreferrer" className="text-primary-custom hover:underline">ouigoo.co</a></p>
            </div>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Données Personnelles Collectées</h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">a) Données d'identification</h3>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Nom et prénom</li>
              <li>Date de naissance</li>
              <li>Photographie (photo de profil)</li>
              <li>Copie de votre pièce d'identité (carte d'identité, passeport ou permis de conduire)</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">b) Données de contact et résidence</h3>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Adresse postale</li>
              <li>Adresse e-mail</li>
              <li>Numéro de téléphone</li>
              <li>Preuve de résidence (facture ou attestation)</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">c) Données professionnelles (facultatives)</h3>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Registre de Commerce (si applicable)</li>
              <li>IFU - Identifiant Fiscal Unique (si applicable)</li>
              <li>Informations sur le véhicule utilisé (type, marque, modèle)</li>
            </ul>
            <p className="text-sm text-gray-600 mb-6">
              Ces informations professionnelles sont recommandées mais non obligatoires lors de l'inscription.
            </p>

            <h3 className="text-xl font-semibold mb-3">d) Données de géolocalisation</h3>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Position GPS en temps réel pendant les courses</li>
              <li>Historique des trajets effectués</li>
              <li>Zones de disponibilité</li>
            </ul>
            <p className="font-semibold bg-blue-50 p-3 rounded-md mb-6">
              La géolocalisation est essentielle au fonctionnement du service et permet aux Clients de suivre leurs livraisons en temps réel.
            </p>

            <h3 className="text-xl font-semibold mb-3">e) Données d'activité et de performance</h3>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Nombre de courses effectuées</li>
              <li>Évaluations et notes des Clients</li>
              <li>Commentaires des Clients</li>
              <li>Taux d'acceptation et d'annulation</li>
              <li>Temps de connexion à l'Application</li>
              <li>Statistiques de performance</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">f) Données financières</h3>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Historique des transactions</li>
              <li>Montant des courses et commissions</li>
              <li>Solde du Portefeuille Électronique</li>
              <li>Coordonnées bancaires (pour les retraits)</li>
              <li>Factures générées</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">g) Données techniques</h3>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Adresse IP</li>
              <li>Type d'appareil et système d'exploitation</li>
              <li>Identifiant unique de l'appareil (IMEI)</li>
              <li>Version de l'Application</li>
              <li>Journaux de connexion et d'utilisation</li>
            </ul>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Base Légale et Finalités du Traitement</h2>
            
            <div className="space-y-6">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold text-lg mb-2">Exécution du contrat</h3>
                <p className="mb-2">Nous traitons vos données pour :</p>
                <ul className="list-disc list-inside space-y-1 pl-4 text-sm">
                  <li>Créer et gérer votre compte Livreur</li>
                  <li>Vous connecter avec les Clients demandant une livraison</li>
                  <li>Traiter les paiements et commissions</li>
                  <li>Fournir l'accès à l'Application et ses fonctionnalités</li>
                  <li>Gérer les litiges et réclamations</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold text-lg mb-2">Consentement</h3>
                <p className="mb-2">Avec votre consentement, nous utilisons vos données pour :</p>
                <ul className="list-disc list-inside space-y-1 pl-4 text-sm">
                  <li>Partager votre géolocalisation en temps réel avec les Clients</li>
                  <li>Vous envoyer des notifications push</li>
                  <li>Vous proposer des offres promotionnelles personnalisées</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold text-lg mb-2">Intérêt légitime</h3>
                <p className="mb-2">Nous traitons vos données pour :</p>
                <ul className="list-disc list-inside space-y-1 pl-4 text-sm">
                  <li>Améliorer la qualité et la sécurité du service</li>
                  <li>Prévenir la fraude et les abus</li>
                  <li>Analyser les performances de la plateforme</li>
                  <li>Développer de nouvelles fonctionnalités</li>
                  <li>Assurer le support technique</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold text-lg mb-2">Obligations légales</h3>
                <p className="mb-2">Nous traitons vos données pour :</p>
                <ul className="list-disc list-inside space-y-1 pl-4 text-sm">
                  <li>Respecter les obligations fiscales et comptables</li>
                  <li>Répondre aux demandes des autorités compétentes</li>
                  <li>Conserver les documents légalement requis</li>
                  <li>Lutter contre le blanchiment d'argent et le financement du terrorisme</li>
                </ul>
              </div>
            </div>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Partage des Données</h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">a) Avec les Clients</h3>
            <p className="mb-4">Nous partageons avec les Clients :</p>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Votre prénom et photo de profil</li>
              <li>Votre note moyenne et nombre de courses</li>
              <li>Votre position GPS en temps réel (pendant la course)</li>
              <li>Les informations sur votre véhicule</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">b) Avec nos prestataires de services</h3>
            <p className="mb-4">Nous pouvons partager vos données avec :</p>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Prestataires de services de paiement</li>
              <li>Fournisseurs de services cloud (hébergement)</li>
              <li>Outils d'analyse et de statistiques</li>
              <li>Services de support client</li>
              <li>Prestataires de vérification d'identité</li>
            </ul>
            <p className="text-sm text-gray-600">
              Ces prestataires sont contractuellement tenus de protéger vos données et ne peuvent les utiliser qu'aux fins pour lesquelles nous les leur communiquons.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">c) Avec les autorités</h3>
            <p className="mb-4">
              Nous pouvons être amenés à communiquer vos données aux autorités compétentes en cas de demande légale ou pour protéger nos droits et ceux de tiers.
            </p>

            <h3 className="text-xl font-semibold mb-3">d) En cas de cession</h3>
            <p className="mb-4">
              En cas de fusion, acquisition ou cession d'actifs, vos données pourront être transférées au nouvel acquéreur, sous réserve du respect de la présente politique.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Sécurité des Données</h2>
            <p className="mb-4">
              Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte, destruction ou divulgation :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Chiffrement des données en transit (HTTPS/TLS)</li>
              <li>Chiffrement des données sensibles au repos</li>
              <li>Authentification forte et gestion des accès</li>
              <li>Surveillance et journalisation des accès</li>
              <li>Sauvegardes régulières et sécurisées</li>
              <li>Tests de sécurité et audits réguliers</li>
              <li>Formation du personnel à la protection des données</li>
              <li>Plans de réponse aux incidents de sécurité</li>
            </ul>
            <p className="font-semibold bg-yellow-100 p-3 rounded-md">
              Malgré ces mesures, aucun système n'est totalement infaillible. Nous vous recommandons de protéger vos identifiants de connexion et de nous signaler immédiatement toute utilisation suspecte de votre compte.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Durée de Conservation</h2>
            
            <div className="space-y-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Pendant la durée du contrat</h3>
                <p className="text-sm">Toutes vos données sont conservées tant que votre compte est actif.</p>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Après la fin du contrat</h3>
                <ul className="list-disc list-inside space-y-1 pl-4 text-sm">
                  <li><strong>Données d'identification :</strong> 5 ans (obligations légales)</li>
                  <li><strong>Données financières :</strong> 10 ans (obligations comptables et fiscales)</li>
                  <li><strong>Données de géolocalisation :</strong> Supprimées après 3 mois</li>
                  <li><strong>Évaluations et notes :</strong> Conservées de manière anonymisée</li>
                  <li><strong>Données techniques :</strong> 1 an maximum</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">En cas de litige</h3>
                <p className="text-sm">Les données pertinentes peuvent être conservées jusqu'à la résolution du litige et l'expiration des délais de recours.</p>
              </div>
            </div>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Vos Droits</h2>
            <p className="mb-4">
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
            </p>

            <div className="space-y-4">
              <div className="border-l-4 border-primary-custom pl-4">
                <h3 className="font-semibold mb-1">Droit d'accès</h3>
                <p className="text-sm text-gray-700">Vous pouvez obtenir une copie de toutes les données personnelles que nous détenons sur vous.</p>
              </div>

              <div className="border-l-4 border-primary-custom pl-4">
                <h3 className="font-semibold mb-1">Droit de rectification</h3>
                <p className="text-sm text-gray-700">Vous pouvez demander la correction de données inexactes ou incomplètes.</p>
              </div>

              <div className="border-l-4 border-primary-custom pl-4">
                <h3 className="font-semibold mb-1">Droit à l'effacement ("droit à l'oubli")</h3>
                <p className="text-sm text-gray-700">Vous pouvez demander la suppression de vos données, sous réserve de nos obligations légales de conservation.</p>
              </div>

              <div className="border-l-4 border-primary-custom pl-4">
                <h3 className="font-semibold mb-1">Droit à la limitation du traitement</h3>
                <p className="text-sm text-gray-700">Vous pouvez demander la suspension temporaire du traitement de vos données dans certaines circonstances.</p>
              </div>

              <div className="border-l-4 border-primary-custom pl-4">
                <h3 className="font-semibold mb-1">Droit à la portabilité</h3>
                <p className="text-sm text-gray-700">Vous pouvez recevoir vos données dans un format structuré et lisible par machine, et les transmettre à un autre responsable de traitement.</p>
              </div>

              <div className="border-l-4 border-primary-custom pl-4">
                <h3 className="font-semibold mb-1">Droit d'opposition</h3>
                <p className="text-sm text-gray-700">Vous pouvez vous opposer au traitement de vos données pour des raisons tenant à votre situation particulière.</p>
              </div>

              <div className="border-l-4 border-primary-custom pl-4">
                <h3 className="font-semibold mb-1">Droit de retirer votre consentement</h3>
                <p className="text-sm text-gray-700">Lorsque le traitement est basé sur votre consentement, vous pouvez le retirer à tout moment.</p>
              </div>

              <div className="border-l-4 border-primary-custom pl-4">
                <h3 className="font-semibold mb-1">Droit de définir des directives post-mortem</h3>
                <p className="text-sm text-gray-700">Vous pouvez définir des directives relatives au sort de vos données après votre décès.</p>
              </div>
            </div>

            <div className="mt-6 bg-blue-50 p-4 rounded-lg">
              <h3 className="font-semibold mb-2">Comment exercer vos droits ?</h3>
              <p className="mb-2">Pour exercer l'un de ces droits, vous pouvez :</p>
              <ul className="list-disc list-inside space-y-1 pl-4 text-sm">
                <li>Nous contacter par email : <a href="mailto:hello@ouigoo.co" className="text-primary-custom hover:underline">hello@ouigoo.co</a></li>
                <li>Accéder aux paramètres de votre compte dans l'Application</li>
              </ul>
              <p className="mt-3 text-sm">
                Nous nous engageons à répondre à votre demande dans un délai d'un (1) mois. Ce délai peut être prolongé de deux (2) mois en cas de complexité de la demande.
              </p>
            </div>

            <div className="mt-6 bg-yellow-50 p-4 rounded-lg">
              <h3 className="font-semibold mb-2">Droit de réclamation</h3>
              <p className="text-sm">
                Si vous estimez que vos droits ne sont pas respectés, vous avez le droit d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) ou de l'autorité de protection des données de votre pays.
              </p>
            </div>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Transferts Internationaux de Données</h2>
            <p className="mb-4">
              Vos données sont principalement stockées et traitées au sein de l'Union Européenne.
            </p>
            <p className="mb-4">
              Si nous devons transférer vos données en dehors de l'UE, nous nous assurons que :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Le pays bénéficie d'une décision d'adéquation de la Commission Européenne, ou</li>
              <li>Des garanties appropriées sont mises en place (clauses contractuelles types, règles d'entreprise contraignantes, etc.)</li>
            </ul>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">9. Cookies et Technologies Similaires</h2>
            <p className="mb-4">
              L'Application utilise des technologies de suivi pour améliorer votre expérience :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement de l'Application</li>
              <li><strong>Cookies analytiques :</strong> Pour comprendre comment vous utilisez l'Application</li>
              <li><strong>Cookies de performance :</strong> Pour améliorer la rapidité et la stabilité</li>
            </ul>
            <p className="text-sm text-gray-600">
              Vous pouvez gérer vos préférences en matière de cookies dans les paramètres de l'Application.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">10. Mineurs</h2>
            <p className="font-semibold bg-red-50 p-4 rounded-md">
              Le Service OuiGoo Livreur est réservé aux personnes majeures. Nous ne collectons pas sciemment de données personnelles auprès de mineurs. Si vous avez connaissance qu'un mineur a fourni des informations, veuillez nous contacter immédiatement.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">11. Modifications de la Politique</h2>
            <p className="mb-4">
              Nous pouvons modifier cette Politique de confidentialité à tout moment pour refléter les changements dans nos pratiques ou pour des raisons légales.
            </p>
            <p className="mb-4">
              Vous serez informé de toute modification importante via :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Une notification dans l'Application</li>
              <li>Un email à l'adresse associée à votre compte</li>
              <li>Un message lors de votre prochaine connexion</li>
            </ul>
            <p className="font-semibold bg-blue-50 p-3 rounded-md">
              La poursuite de l'utilisation du Service après l'entrée en vigueur des modifications vaudra acceptation de la nouvelle Politique.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">12. Contact et Délégué à la Protection des Données</h2>
            <p className="mb-4">
              Pour toute question concernant cette Politique de confidentialité ou vos données personnelles, vous pouvez nous contacter :
            </p>
            <div className="bg-gray-100 p-4 rounded-lg mb-6">
              <p className="font-semibold">Ozinex - Service OuiGoo</p>
              <p className="mt-2"><strong>Email :</strong> <a href="mailto:hello@ouigoo.co" className="text-primary-custom hover:underline">hello@ouigoo.co</a></p>
              <p><strong>Site web :</strong> <a href="https://ouigoo.co" target="_blank" rel="noopener noreferrer" className="text-primary-custom hover:underline">ouigoo.co</a></p>
            </div>
            <p className="text-sm text-gray-600">
              Nous nous engageons à répondre à vos questions dans les meilleurs délais et à traiter vos demandes avec le plus grand soin.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-center">Résumé de vos Droits</h2>
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg">
              <div className="grid md:grid-cols-2 gap-4">
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">✓</span>
                  <div>
                    <p className="font-semibold">Transparence</p>
                    <p className="text-sm text-gray-700">Vous savez quelles données nous collectons</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">✓</span>
                  <div>
                    <p className="font-semibold">Contrôle</p>
                    <p className="text-sm text-gray-700">Vous pouvez accéder et modifier vos données</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">✓</span>
                  <div>
                    <p className="font-semibold">Sécurité</p>
                    <p className="text-sm text-gray-700">Vos données sont protégées</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">✓</span>
                  <div>
                    <p className="font-semibold">Respect</p>
                    <p className="text-sm text-gray-700">Nous respectons vos droits RGPD</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DriverPrivacyPolicy;
